import {  TAutomationApp } from "../../";

export type TOperationHoursCounter = {
    value: number;
    valueDelta: number;
    reset: boolean;
    timeOfReset: Date | undefined;
} & TAutomationApp


export const schema = 'AutomationApps.Devices.Counters.OperationHoursCounter';